var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgNeuro6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1875,
    height: 1552,
    viewBox: "0 0 1875 1552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_538_3498)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1874.36 0H0V1551.73H1874.36V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M627.352 384.471C639.975 359.91 670.117 350.232 694.678 362.855L1404.1 727.451C1428.67 740.073 1438.34 770.216 1425.72 794.777L1247.23 1142.08C1234.61 1166.64 1204.58 1176.38 1180.02 1163.76C1102.87 1124.12 941.143 1041.02 825.472 981.535C710.047 922.174 547.74 838.778 470.382 799.035C445.817 786.414 436.245 756.324 448.869 731.761L627.352 384.471Z",
    fill: "url(#paint0_linear_538_3498)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_3498",
    x1: 1279.53,
    y1: 933.024,
    x2: 812.53,
    y2: 399.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#055094",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6DAAE2",
    stopOpacity: 0.13
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_538_3498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1875,
    height: 1552,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgNeuro6);
export default __webpack_public_path__ + "static/media/bg-neuro6.1b167896ccfd67dd6d0a261941ce7953.svg";
export { ForwardRef as ReactComponent };